import { Dialog } from "@headlessui/react";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { useTranslation } from "react-i18next";

export default function VariableContractDialog({ showDialog, setShowDialog }) {
  const { t } = useTranslation();
  const closeDialog = () => {
    setShowDialog(false);
  };

  return (
    <Dialog
      open={showDialog}
      onClose={() => closeDialog()}
      className="ui-dialogs"
    >
      <DialogBackdrop />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog w-full max-w-2xl"
        >
          <Dialog.Title className="font-body text-lg font-bold text-left pr-8">
            {t("VariableContractDialog-dialogTitle")}
          </Dialog.Title>

          <button
            className="ui-default-dialog-close"
            aria-label="close contact information update unavailable dialog"
            onClick={() => closeDialog()}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>

          <hr />

          <Dialog.Description className="mt-4">
            {t("VariableContractDialog-dialogDescription")}
          </Dialog.Description>

          <div className="block text-right mt-6">
            <button
              type="button"
              className="ui-btn-secondary ui-btn-min-w mt-4"
              onClick={() => closeDialog()}
            >
              Close
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
